/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";

import * as Types from "../../generated/types";

const defaultOptions = {} as const;
export type OnStackContainerSavedSubscriptionVariables = Types.Exact<{
  numberUuid: Types.Scalars["ID"];
  stackContainerUuid: Types.Scalars["ID"];
}>;

export type OnStackContainerSavedSubscription = {
  __typename: "RootSubscriptionType";
  onStackContainerSaved: {
    __typename: "StackContainer";
    uuid: string;
    notebookRevisions: {
      __typename: "NotebookRevisionConnection";
      revisions: Array<{
        __typename: "NotebookRevisionPreview";
        uuid: string;
        accountUuid: string | null;
        insertedAt: any;
      } | null>;
    };
  };
};

export const OnStackContainerSavedDocument = gql`
  subscription onStackContainerSaved($numberUuid: ID!, $stackContainerUuid: ID!) {
    onStackContainerSaved(numberUuid: $numberUuid, stackContainerUuid: $stackContainerUuid) {
      uuid
      notebookRevisions(limit: 1, offset: 0) {
        revisions {
          uuid
          accountUuid
          insertedAt
        }
      }
    }
  }
`;

/**
 * __useOnStackContainerSavedSubscription__
 *
 * To run a query within a React component, call `useOnStackContainerSavedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStackContainerSavedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStackContainerSavedSubscription({
 *   variables: {
 *      numberUuid: // value for 'numberUuid'
 *      stackContainerUuid: // value for 'stackContainerUuid'
 *   },
 * });
 */
export function useOnStackContainerSavedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnStackContainerSavedSubscription,
    OnStackContainerSavedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<OnStackContainerSavedSubscription, OnStackContainerSavedSubscriptionVariables>(
    OnStackContainerSavedDocument,
    options
  );
}
export type OnStackContainerSavedSubscriptionHookResult = ReturnType<typeof useOnStackContainerSavedSubscription>;
export type OnStackContainerSavedSubscriptionResult = Apollo.SubscriptionResult<OnStackContainerSavedSubscription>;
